import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
const CHECKOUT_BASE = 'https://academiaholisticaargentina.com/cart/48552680259801:1';
const CHECKOUT_PRO = 'https://academiaholisticaargentina.com/cart/48552681668825:1';
function getSecondsUntilEndOfDay() {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 0, 0);
  const diff = Math.floor((end.getTime() - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilEndOfDay);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilEndOfDay());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="relative bg-[#1C1410] text-[#F5ECD7] py-12 md:py-16 px-5 sm:px-6 overflow-hidden border-t border-[#C9A96E]/10" data-id="element-37">
      <div ref={ref1} className={`reveal container mx-auto max-w-4xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-38">
        <p className="text-[#F5ECD7] font-serif italic text-2xl md:text-3xl font-bold mb-10" data-id="element-39">
          El cambio que siempre esperaste puede empezar hoy.
          <br data-id="element-40" />
          <span className="text-[#C9A96E]" data-id="element-41">
            "El momento que siempre esperaste ya llegó." 🌹
          </span>
        </p>

        <div className="mb-10" data-id="element-42">
          <h2 className="text-2xl md:text-3xl font-bold text-[#F5ECD7] mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-43">
            ⏰ EL PRECIO CIERRA EN:
          </h2>

          <div className="flex items-center justify-center gap-2" data-id="element-44">
            <span className="bg-[#2D1B1B] border border-[#C9A96E]/20 text-[#F5ECD7] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-45">
              {String(hours).padStart(2, '0')}
            </span>
            <span className="text-[#FAF3E8]/50 text-xl font-bold" data-id="element-46">hs</span>
            <span className="text-[#C9A96E] text-2xl font-bold animate-pulse" data-id="element-47">
              :
            </span>
            <span className="bg-[#2D1B1B] border border-[#C9A96E]/20 text-[#F5ECD7] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-48">
              {String(minutes).padStart(2, '0')}
            </span>
            <span className="text-[#FAF3E8]/50 text-xl font-bold" data-id="element-49">min</span>
            <span className="text-[#C9A96E] text-2xl font-bold animate-pulse" data-id="element-50">
              :
            </span>
            <span className="bg-[#2D1B1B] border border-[#C9A96E]/20 text-[#F5ECD7] px-3 py-2 rounded-lg text-2xl md:text-3xl font-bold" style={{
            fontFamily: "'Bebas Neue', sans-serif",
            letterSpacing: '0.1em'
          }} data-id="element-51">
              {String(seconds).padStart(2, '0')}
            </span>
            <span className="text-[#FAF3E8]/50 text-xl font-bold" data-id="element-52">seg</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-10" data-id="element-53">
          {/* Pro CTA */}
          <div className="bg-gradient-to-b from-[#2D1B1B] to-[#1C1410] rounded-xl p-5 sm:p-6 border-2 border-[#C9A96E]/50 flex flex-col justify-between relative shadow-[0_0_30px_rgba(201,169,110,0.15)]" data-id="element-54">
            <div className="mb-6" data-id="element-55">
              <h3 className="text-xl font-bold text-[#F5ECD7] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-56">
                🏆 EL CÓDIGO + PROTOCOLO DE SOBERANÍA TOTAL ⭐
              </h3>
              <p className="text-[#C9A96E] font-bold text-sm mb-4" data-id="element-57">
                6 Tomos + 6 Bonos + Guía Maestra de Blindaje Emocional
              </p>
              <p className="text-[#D4A5A5] text-sm line-through" data-id="element-58">$89.000</p>
              <p className="text-4xl sm:text-5xl font-extrabold text-[#C9A96E]" style={{
              textShadow: '0 0 30px rgba(201,169,110,0.4)'
            }} data-id="element-59">
                $27.990{' '}
                <span className="text-xl font-bold text-[#F5ECD7]" data-id="element-60">ARS</span>
              </p>
            </div>
            <a href={CHECKOUT_PRO} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-[#F5ECD7] hover:text-[#1C1410] font-bold text-sm tracking-widest uppercase transition-all shadow-[0_0_30px_rgba(139,38,53,0.4)] hover:shadow-[0_0_40px_rgba(201,169,110,0.6)] hover:-translate-y-1 bg-[#8B2635] hover:bg-[#C9A96E] border border-[#8B2635] hover:border-[#C9A96E] text-center" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-61">
              → QUIERO EL CÓDIGO + PROTOCOLO DE SOBERANÍA TOTAL
            </a>
          </div>

          {/* Base CTA */}
          <div className="bg-[#2D1B1B] rounded-xl p-5 sm:p-6 border border-[#C9A96E]/20 flex flex-col justify-between shadow-lg" data-id="element-62">
            <div className="mb-6 pt-6" data-id="element-63">
              <h3 className="text-xl font-bold text-[#F5ECD7] mb-2" style={{
              fontFamily: "'Playfair Display', serif"
            }} data-id="element-64">
                📘 EL CÓDIGO DE LA HIJA LIBRE
              </h3>
              <p className="text-[#F5ECD7] font-bold text-sm mb-4" data-id="element-65">
                6 Tomos + 6 Bonos · Método Sistémico Completo
              </p>
              <p className="text-[#D4A5A5] text-sm line-through" data-id="element-66">$69.000</p>
              <p className="text-4xl sm:text-5xl font-extrabold text-[#F5ECD7]" style={{
              textShadow: '0 0 30px rgba(245,236,215,0.15)'
            }} data-id="element-67">
                $19.990{' '}
                <span className="text-xl font-bold text-[#FAF3E8]" data-id="element-68">ARS</span>
              </p>
            </div>
            <a href={CHECKOUT_BASE} target="_blank" rel="noopener noreferrer" className="w-full block px-4 py-4 rounded-xl text-[#F5ECD7] hover:text-[#1C1410] font-bold text-sm tracking-widest uppercase transition-all hover:-translate-y-1 bg-[#8B2635] hover:bg-[#C9A96E] border border-[#8B2635] hover:border-[#C9A96E] text-center shadow-[0_0_20px_rgba(139,38,53,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)]" style={{
            fontFamily: "'Inter', sans-serif",
            letterSpacing: '0.05em'
          }} data-id="element-69">
              → QUIERO MI CÓDIGO
            </a>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-[#C4856A] text-xs md:text-sm font-medium" data-id="element-70">
          <span className="flex items-center gap-1.5" data-id="element-71">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-72">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-73">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-74">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}